export default [
  {
    path: '/admin/payment-vendors',
    name: 'payment-vendor',
    meta: { requiresAuth: true },
    component: () => import('@/pages/supplier/payment/index.vue')
  },
  {
    path: '/admin/payment-vendors/create',
    name: 'supplier-payment-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/supplier/payment/create.vue')
  }
]
